import React from 'react'
import {makeStyles} from "@material-ui/core/styles";
import {Card, Avatar, Hidden} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import FuseAnimate from "../fuse-animate/fuse-animate";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import { PhoneAndroid } from "@material-ui/icons"
import ausPhone from "../../utils/aus-phone";



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    avatar: {
        // background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        width: theme.spacing(5),
        height: theme.spacing(5),
        fontSize: 18,
    },
    avatarLarge: {
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        width: theme.spacing(15),
        height: theme.spacing(15),
        fontSize: 48,
        marginBottom: 8,
        marginTop: 8,
    },
    avatarRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom:  12,
    },
    greeting: {
        paddingLeft: 12,
        paddingRight: 4,
    },
    userName: {
        fontWeight: 500,
    },
    addressRow: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop:  4,
        paddingLeft: 8,
    },
    address: {
      paddingLeft: 8,
    },
    linkButton: {
        marginTop: 24,
    },
    sideLinkButton: {
        minWidth: 180,
    },
    link: {
        color: '#047e9f',
        fontWeight: 700,
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: '#047e9f',
        },
    },
}));

const UserProfile = ({user, variant='home', animation, delay}) => {

    return (
        <>
            { variant === 'home' ?
                <HomeProfile user={user} animation={animation} delay={delay}/>
                :
                <AccountProfile user={user} animation={animation} delay={delay}/>
            }
        </>
    )
}


const HomeProfile = ({user, animation, delay}) => {
    const classes = useStyles();

    // The initials are used as a fallback for the avatar if the user hasn't selected one.

    const initials = user.firstName && user.lastName ?
        user.firstName.charAt(0) + user.lastName.charAt(0) : '';
    const avatarUrl = '/assets/images/avatars/' + user.avatarUrl;

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="profile-card" className={classes.root}>

                <Grid container style={{justifyContent: 'space-between', alignItems: 'center'}}>
                    <Grid item>
                        <div className={classes.avatarRow}>
                            <Avatar className={classes.avatar} src={avatarUrl}>{initials}</Avatar>
                            <Typography className={classes.greeting} color="textSecondary" variant="body1">
                                {getGreeting()}, <strong>{user.firstName}</strong>
                            </Typography>
                        </div>

                        <div className={classes.addressRow}>
                            <PhoneAndroid color="action"/><Typography color="textSecondary" variant="body2" className={classes.address}>{ausPhone(user.phone)}</Typography>
                        </div>
                    </Grid>

                    <Grid item>
                        <Hidden smDown>
                            <Button variant="outlined"
                                    color="primary"
                                    size="large"
                                    component={Link}
                                    to={{pathname: "/account", state: {scrollTo: 'personal-details'}}}
                                    className={classes.sideLinkButton}
                            >Change Profile</Button>
                        </Hidden>
                    </Grid>

                </Grid>
                <Hidden mdUp>
                    <Button variant="outlined"
                            color="primary"
                            size="large"
                            component={Link}
                            to={{pathname: "/account",  state: {scrollTo: 'personal-details'}}}
                            className={classes.linkButton}
                    >Change Profile</Button>
                </Hidden>

            </Card>
        </FuseAnimate>
    )
}


const AccountProfile = ({user, animation, delay}) => {
    const classes = useStyles();

    // The initials are used as a fallback for the avatar if the user hasn't selected one.
    const initials = user.firstName && user.lastName ?
                        user.firstName.charAt(0) + user.lastName.charAt(0) : '';
    const avatarUrl = '/assets/images/avatars/' + user.avatarUrl;

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="profile-card" className={classes.root}>
                <div className="flex flex-col items-center">
                    <Avatar src={avatarUrl} className={classes.avatarLarge} >{initials}</Avatar>
                    <Typography variant="h5" color="secondary" align="center">{user.firstName} {user.lastName}</Typography>
                    <div className="text-lg">{ausPhone(user.phone)}</div>
                    <div className="mt-3 flex">Account Number <span className="ml-1">{user.accountId}</span></div>
                    <div className="mt-1"><i>Customer for {howLong(user.dateRegistered)}</i></div>
                    <div className="my-3 border-t w-9/12"/>
                    <div className="mb-2">
                        <Link className={classes.link} to="/account/change-password">
                            Change Password
                        </Link>
                    </div>
                </div>
            </Card>
        </FuseAnimate>
    )
}

/***
 * Returns a time-of-day greeting given an hour
 * If the hour is undefined the current hour is used.
 *
 * @param hour
 * @returns {string}
 */
function getGreeting() {
    const hour = moment().hour();
    let greeting = "Good evening";
    if (hour > 11 && hour < 18) {
        greeting = "Good afternoon";
    } else if (hour > 4 && hour < 12) {
        greeting = "Good morning"
    }
    return greeting
}

function howLong(joined) {
    const duration = moment.duration(moment().diff(moment(joined)));
    const years = duration.years()
    const months = duration.months();
    const yr = years === 1 ? 'year' : 'years'
    const mth = months === 1 ? 'month' : 'months'
    if (years === 0 && months === 0) {
        return duration.humanize()
    } else if (years > 0) {
        if (months > 0) {
            return `${years} ${yr} and ${months} ${mth}`
        }
        return `${years} ${yr}`
    } else {
        return `${months} ${mth}`
    }
}


export default UserProfile;